// extracted by mini-css-extract-plugin
export default {"selecterptd":"defaultmapping_selecterptd__Ny8bB","selectecommercetd":"defaultmapping_selectecommercetd__Njnqr","mappingtableContainer":"defaultmapping_mappingtableContainer__15Cky"};